import { DetailsBooking } from 'types';

export const showAdyenMigrationInfo = (booking: DetailsBooking): boolean => {
  const notYetMigrateToAdyenPaymentGateway = booking.flags.requiresPaymentMethodUpdate;
  return notYetMigrateToAdyenPaymentGateway;
};
